module.exports = __webpack_public_path__ + "img/user_bg.e63aae97.png";